import(/* webpackMode: "eager" */ "/app/app/voting/page.tsx");
